<script>
import {
  maxValue,
  minValue,
  required,
  requiredIf
} from "vuelidate/lib/validators";

export default {
  methods: {
    showAutoIncrease(design) {
      return (
        +design.auto_increase_available === 2 ||
        +design.auto_increase_available === 3
      );
    },
    showAutoIncreasePriorEmployees(design) {
      return +design.auto_increase_available === 2;
    },
    autoIncreaseValidations(design) {
      return {
        auto_increase_available: { required },
        auto_increase_applies_prior_employees: {
          required: requiredIf(() => this.showAutoIncreasePriorEmployees(design))
        },
        auto_increase_effective_date: {
          required: requiredIf(() => this.showAutoIncrease(design))
        },
        auto_increase_annual_increase: {
          required: requiredIf(() => this.showAutoIncrease(design)),
          minValue: minValue(0.01),
          maxValue: maxValue(0.15),
          percent: true
        },
        auto_increase_type: {
          required: requiredIf(() => this.showAutoIncrease(design))
        },
        auto_increase_maximum: {
          required: requiredIf(() => this.showAutoIncrease(design)),
          minValue: minValue(
            Math.max(design.auto_increase_annual_increase, 0.01)
          ),
          maxValue: maxValue(0.15),
          percent: true
        },
        auto_increase_date_type: {
          required: requiredIf(() => this.showAutoIncrease(design))
        }
      };
    }
  }
};
</script>
